
import axios from "axios";
import qs from "qs";

const getConfiguracion = async () => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");
  
  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, serialNumberKeyClover };

    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Inventario/GetConfiguracion`, body, { headers });
    return data;
  } catch (error) {
    console.error("Error en getConfiguracion:", error.response?.data || error.message);
    throw error;
  }
};

const getStockTeoricoIMA = async (idArticulo, idDeposito, fecha) => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");
  
  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, idArticulo, idDeposito, fecha, serialNumberKeyClover };

    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Inventario/GetStockTeoricoIMA`, body, { headers });
    return Number(data.stockTeorico);
  } catch (error) {
    console.error("Error en getStockTeorico:", error.response?.data || error.message);
    throw error;
  }
};

const getArticuloIMAPorCodigoDeBarras = async ({ codBarra, buscarEnSinonimos, buscarEnCodigo }) => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");
  
  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, codBarra, buscarEnSinonimos, buscarEnCodigo, serialNumberKeyClover };
    
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Inventario/GetArticuloIMAPorCodigoDeBarras`, body, { headers });
    return data;
  } catch (error) {
    console.error("Error en getArticuloIMAPorCodigoDeBarras:", error.response?.data || error.message);
    throw error;
  }
};

const getMovimientoStock = async (idArticulo, idDeposito) => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");
  
  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, idArticulo, idDeposito, serialNumberKeyClover };

    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Inventario/GetMovimientoStock`, body, { headers });
    return data;
  } catch (error) {
    console.error("Error en getMovimientoStock:", error.response?.data || error.message);
    throw error;
  }
};

const persistirAjustes = async (idEmpleado, idDeposito, movimientos) => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");

  try {
    const body = qs.stringify({
      idEmpleado,
      idDeposito,
      movimientos: JSON.stringify(movimientos),
      nic,
      serialNumberKeyClover,
    });

    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Inventario/PersistirAjustes`, body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`
      },
    });

    return data;
  } catch (error) {
    console.error("Error en persistirAjustes:", error.response?.data || error.message);
    throw error;
  }
};

const getArticuloIMAPorId = async (idArticulo) => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");
  
  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, idArticulo, serialNumberKeyClover };
    
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Inventario/GetArticuloIMAPorId`, body, { headers });
    return data;
  } catch (error) {
    console.error("Error en getArticuloIMAPorId:", error.response?.data || error.message);
    throw error;
  }
};

const getListaArticulosIMA = async (idDeposito) => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");

  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, idDeposito, serialNumberKeyClover };

    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Inventario/GetListaArticulosIMA`, body, { headers });

    if (!Array.isArray(data)) {
      console.warn("La respuesta no es un array:", data);
      throw new Error("La respuesta no es una lista de artículos");
    }

    return data;
  } catch (error) {
    console.error("Error en getListaArticulosIMA:", error.response?.data || error.message);
    throw error;
  }
};

const inventario = {
  getConfiguracion,
  getStockTeoricoIMA,
  getArticuloIMAPorCodigoDeBarras,
  getMovimientoStock,
  persistirAjustes,
  getArticuloIMAPorId,
  getListaArticulosIMA,
};

export default inventario;
